import { memo } from 'react';

import CardForm from 'components/CardForm';
import SelectedProductItem from 'components/SelectedProductItem';
import { If, Divider } from 'shared';
import { Column, Row } from 'shared/Houston';
import { IProduct } from 'types/interfaces';

import { PositionLabel } from './styles';

interface IProps {
  product: IProduct;
  position?: {
    order: number;
    label?: string;
  };
  action?: React.ReactNode;
  footer?: React.ReactNode;
}

const SelectedProductItemCardForm: React.FC<IProps> = ({ product, position, action, footer }) => {
  return (
    <CardForm disablePaddingBottom>
      <If condition={!!position}>
        <Row>
          <Column xs={12}>
            <PositionLabel size='xxs'>
              #{position?.order} {position?.label}
            </PositionLabel>
            <Divider />
          </Column>
        </Row>
      </If>

      <SelectedProductItem product={product} action={action} isPreview footer={footer} />
    </CardForm>
  );
};

export default memo(SelectedProductItemCardForm);
